module.exports = __webpack_public_path__ + "static/media/schody62 - schody drewniane zabiegowe do garazu.3bf0b13d.jpg";